import {
  siFacebook,
  siInstagram,
  siSnapchat,
  siTelegram,
  siTiktok,
  siWhatsapp,
  siX,
  siYoutube,
} from 'simple-icons';

/**
 * Logos officiels des réseaux sociaux.
 *
 * Les glyphes viennent de Simple Icons, qui les tient à jour — un logo dessiné
 * de mémoire vieillit mal et se reconnaît moins bien. LinkedIn en a été retiré
 * à la demande de son propriétaire : il est rendu par sa marque écrite, sur sa
 * couleur, plutôt que par une approximation du glyphe officiel.
 */
const glyphes: Record<string, { path: string; couleur: string; titre: string }> = {
  facebook: { path: siFacebook.path, couleur: `#${siFacebook.hex}`, titre: 'Facebook' },
  instagram: { path: siInstagram.path, couleur: `#${siInstagram.hex}`, titre: 'Instagram' },
  x: { path: siX.path, couleur: `#${siX.hex}`, titre: 'X' },
  youtube: { path: siYoutube.path, couleur: `#${siYoutube.hex}`, titre: 'YouTube' },
  whatsapp: { path: siWhatsapp.path, couleur: `#${siWhatsapp.hex}`, titre: 'WhatsApp' },
  telegram: { path: siTelegram.path, couleur: `#${siTelegram.hex}`, titre: 'Telegram' },
  tiktok: { path: siTiktok.path, couleur: `#${siTiktok.hex}`, titre: 'TikTok' },
  snapchat: { path: siSnapchat.path, couleur: `#${siSnapchat.hex}`, titre: 'Snapchat' },
};

const LINKEDIN = '#0A66C2';

/**
 * Le logo d'un réseau, à la taille demandée.
 *
 * `enCouleur` peint le glyphe aux couleurs de la marque ; sinon il prend la
 * couleur courante du texte, ce qui convient à une liste d'administration où
 * neuf logos bariolés feraient sapin de Noël.
 */
export default function LogoReseau({
  reseau,
  taille = 24,
  enCouleur = true,
  className = '',
}: {
  reseau: string;
  taille?: number;
  enCouleur?: boolean;
  className?: string;
}) {
  if (reseau === 'linkedin') {
    return (
      <span
        className={`inline-flex items-center justify-center rounded font-bold leading-none ${className}`}
        style={{
          width: taille,
          height: taille,
          backgroundColor: enCouleur ? LINKEDIN : 'currentColor',
          color: enCouleur ? '#fff' : 'transparent',
          fontSize: taille * 0.5,
        }}
        title="LinkedIn"
        aria-hidden="true"
      >
        in
      </span>
    );
  }

  const glyphe = glyphes[reseau];
  if (!glyphe) return null;

  return (
    <svg
      role="img"
      aria-hidden="true"
      width={taille}
      height={taille}
      viewBox="0 0 24 24"
      fill={enCouleur ? glyphe.couleur : 'currentColor'}
      className={className}
    >
      <title>{glyphe.titre}</title>
      <path d={glyphe.path} />
    </svg>
  );
}
